"use client"

import { useState } from "react"
import "../../app/styles/components/Header.scss";

import { Menu, X } from "lucide-react"

export default function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen)
  }

  return (
    <header className="header">
      <div className="headerContainer">
        <nav className="nav">
          <a href="/" className="logo">
            Mahaa&apos;s Diary Farms
          </a>


          <div className="navLinks">
            <a href="#home" className="navLink">
              Home
            </a>
            <a href="#about" className="navLink">
              About
            </a>
            <a href="#products" className="navLink">
              Products
            </a>
            <a href="#contact" className="navLink">
              Contact
            </a>
          </div>

          <button className="mobileMenuButton" onClick={toggleMobileMenu} aria-label="Toggle mobile menu">
            {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </nav>

        <div className={`mobileMenu ${mobileMenuOpen ? "open" : ""}`}>
          <a href="#home" className="navLink" onClick={() => setMobileMenuOpen(false)}>
            Home
          </a>
          <a href="#about" className="navLink" onClick={() => setMobileMenuOpen(false)}>
            About
          </a>
          <a href="#products" className="navLink" onClick={() => setMobileMenuOpen(false)}>
            Products
          </a>
          <a href="#contact" className="navLink" onClick={() => setMobileMenuOpen(false)}>
            Contact
          </a>
        </div>
      </div>
    </header>
  )
}